/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../../layouts/one-visual";
import { getRequest } from '../../../../../api/ApiService';

import IncomeStatementWidget from "../../../../finance/widgets/income-statement";

class MarketShareStep1 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      incomeStatement: {
        costOfSales: {
          name: "Cost of Sales",
          data: {}
        },
        revenues: {
          name: "Net Revenues",
          data: {}
        },
        grossProfits: {
          name: "Gross Profit",
          data: {}
        },
        RnDCosts: {
          name: "R&D Costs",
          data: {}
        },
        holdingCosts: {
          name: "Holding Costs",
          data: {}
        },
        promotionCosts: {
          name: "Promotion Costs",
          data: {}
        },
        sellingCosts: {
          name: "Selling Costs",
          data: {}
        },
        gnACosts: {
          name: "Other G&A Costs",
          data: {}
        },
        incomingBeforeTaxes: {
          name: "Income Before Taxes",
          data: {}
        },
        taxes: {
          name: "Taxes",
          data: {}
        },
        totalOperatingExpenses: {
          name: "Total Operating Costs",
          data: {}
        },
        totalNonOperatingCost: {
          name: "Total Non-Operating Costs",
          data: {}
        },
        gainOrLossoFSales: {
          name: "Gain or Loss of Sales",
          data: {}
        },
        interestExpense: {
          name: "Interest Expense",
          data: {}
        },
        otherNonOperatingCosts: {
          name: "Other Non-Operating Costs",
          data: {}
        },
        netIncome: {
          name: "Net Income",
          data: {}
        }
      },
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    let incomeStatement = { ...this.state.incomeStatement };

    for (let key in incomeStatement) {
      incomeStatement[key].data = {
        value: 0
      };
    }

    getRequest(`${process.env.REACT_APP_API_URL}team/report/income_statement/?round_lte=${activeRound}`)
      .then(res => {
        for (let key in incomeStatement) {
          // eslint-disable-next-line
          res.body.forEach(item => {
            let round_id = item.round;
            let round = rounds.find(i => i.id === round_id);
            let round_number = round.number;
            const hash = incomeStatement[key].name;

            if (round_number === activeRound && item[hash]) {
              incomeStatement[key].data.value = item[hash];
            }
          });
        }

        this.setState({
          incomeStatement,
        });
      })
      .catch(err => {});
  }

  render() {
    const { activeRound } = this.props;
    const { incomeStatement } = this.state;

    return (
      <OneVisualLayout
        section="FEEDBACK"
        subSection="NET LOSS"
        title="Negative Profits"
        paragraph1={(
          <Fragment>
            Unfortunately, your company's expenses (i.e. red line items) exceeded revenues and as a result, your
            company generated negative profits, which adversely impacted your team's ability to hit any profitability
            targets (e.g. ROE, ROA, or EPS).
          </Fragment>
        )}
        visual={(
          <IncomeStatementWidget
            incomeStatement={incomeStatement}
            current_year={activeRound}
            className="team-reports-with-scroll-2"
            isPerformanceFeedback={true}
          />
        )}
        visualProps={{
          padding: '10px',
        }}
      />
    );
  }

}

export default MarketShareStep1;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/net-loss/step1.js